<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row row-cols-1 row-cols-xl-3 mb-5">
        <div class="col col-xl-5 mb-2">
          <div class="row">
            <div class="col-12">
              <a
                href="https://primepark.com.au/location/sydney-markets"
                target="_blank"
                class="card prime-park-card h-100 shadow"
              >
                <div
                  class="card-body d-flex align-items-center justify-content-center text-white"
                >
                  <h4 class="text-center mb-0">
                    Entry & Parking Passes
                    <md-icon class="m-1" style="color: white !important;"
                      >arrow_right_alt</md-icon
                    >
                  </h4>
                </div>
              </a>
            </div>
          </div>
          <h3 class="mt-4">Market Access Passes</h3>
          <div class="row">
            <div v-for="(pass, id) in passes" :key="id" class="col-12 mb-2">
              <div class="card h-100 text-center shadow">
                <div class="row g-0">
                  <div
                    class="col-sm-5 d-flex align-items-center justify-content-center p-3"
                  >
                    <div>
                      <img
                        src="@/assets/icons/user-regular.svg"
                        class="img-fluid mb-3 px-4"
                        alt="user icon"
                      />
                      <br />Pass No.
                      <span class="fw-bold">{{
                        pass.card_number || "[not collected]"
                      }}</span>
                      <p
                        class="mb-0"
                        :class="
                          pass.in_prepurchase ? 'text-danger' : 'text-muted'
                        "
                      >
                        Expires:
                        {{ pass.expiry }}
                      </p>
                      <a
                        v-if="pass.in_prepurchase"
                        href="#"
                        class="text-danger"
                        @click.prevent="renew(pass)"
                        >Renew Now</a
                      >
                    </div>
                  </div>
                  <div class="col-sm-7 d-flex align-items-center">
                    <div class="card-body p-4">
                      <md-icon
                        :md-src="pass.icon"
                        class="icon"
                        :class="pass.color"
                      />
                      <div
                        class="card-title"
                        :class="'text-' + pass.color.substring(11)"
                      >
                        <p class="md-subheading fw-bold mb-1">
                          {{ pass.name }}
                        </p>
                      </div>
                      <p class="pt-1">
                        <router-link
                          to="account"
                          class="text-uppercase fw-bold text-black"
                          >{{ authUser.first_name }}
                          {{ authUser.last_name }}
                        </router-link>
                        <br />{{
                          authUser.business
                            ? authUser.business.business_name
                            : ""
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <router-link to="/access-passes" class="card h-100 shadow">
                <div
                  class="card-body d-flex align-items-center justify-content-center"
                >
                  <div class="text-center">
                    <md-icon class="m-1">add_circle_outline</md-icon>
                    View or Update Access Passes
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <div class="col col-xl-7">
          <h3>WHS Information</h3>
          <div class="row row-cols-1 row-cols-sm-2 g-4 mb-5">
            <div class="col">
              <button-image
                url="https://www.sydneymarkets.com.au/markets/whs/work-health-safety-management-plan.html"
                :image="require('@/assets/img/whs_management_plan.jpg')"
                title="WHS Management Plan"
                :router-link="false"
              />
            </div>
            <div class="col">
              <button-image
                url="https://www.sydneymarkets.com.au/markets/whs/safety-notices.html"
                :image="require('@/assets/img/safety_notices.jpg')"
                title="Safety Notices"
                :router-link="false"
              />
            </div>
            <div class="col">
              <button-image
                url="induction"
                :image="require('@/assets/img/induction.jpg')"
                title="Induction"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col-md-6">
          <h3>SML Trader App</h3>
          <p>
            Download the SML Trader App for alerts and notices
          </p>
          <a
            href="https://apps.apple.com/au/app/sml-trader/id1217341213"
            target="_blank"
          >
            <img
              src="@/assets/icons/icon_App-Store.svg"
              class="img-fluid m-1"
              style="width: 150px;"
              alt="app store"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.schoolenews.sydneymarkets2129&hl=en&gl=US"
            target="_blank"
          >
            <img
              src="@/assets/icons/icon_Google-Play.png"
              class="img-fluid m-1"
              style="max-width: 150px;"
              alt="google play"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonImage from "../components/Buttons/ButtonImage.vue";
import { mapGetters } from "vuex";
import Cookies from "js-cookie";

export default {
  components: {
    ButtonImage
  },
  computed: {
    passes() {
      let passes = [];

      this.authUser?.passes.forEach(pass => {
        passes.push({
          id: pass.id,
          type: pass.type,
          name: pass.name,
          card_number: pass.card_number,
          icon: this.$helpers.pass.getIcon(pass.type),
          color: this.$helpers.pass.getColor(pass.type),
          in_prepurchase: pass.in_prepurchase,
          expiry: pass.expires_at
            ? this.$moment(pass.expires_at)
                .subtract(1, "days")
                .format("DD/MM/YYYY")
            : "Renews 1st July"
        });
      });

      return passes;
    },
    ...mapGetters(["authUser"])
  },
  mounted() {
    if (Cookies.get("whs_done") !== "true") {
      this.$toast.warning(
        "Please complete the WHS Information modules before continuing.",
        {
          duration: 10000
        }
      );
      Cookies.set("whs_done", "true", { expires: 365, secure: true });
    }
  },
  methods: {
    renew(pass) {
      this.$store.dispatch("setCart", [this.authUser]).then(() => {
        this.$router.push("/cart");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.icon {
  margin: 1rem auto !important;
  width: auto;
  height: 40px !important;

  &-primary {
    svg {
      fill: #5bb061 !important;
    }
  }
}

.card {
  border-color: transparent !important;
}

.shadow {
  -webkit-box-shadow: 0 1px 4px 0 rgb(0 0 0 / 14%) !important;
  box-shadow: 0 1px 4px 0 rgb(0 0 0 / 14%) !important;
}

.prime-park-card {
  background-color: #2560a6;
}
</style>
